import Modal from 'react-bootstrap/Modal'
import * as React from 'react'
import EULA from './EULA'
import { FunctionComponent } from 'react'

interface Props {
  show: boolean
  closeModal: () => void
  customEULA?: string
  companyName?: string
}

const EULAModal: FunctionComponent<Props> = (props: Props) => {
  return (
    <Modal
      show={props.show}
      onHide={props.closeModal}
      centered={true}
      className="w-modal-eula"
      size="lg"
    >
      <Modal.Body>
        <div className="w-modal">
          <div className="container">
            <i
              className="fas fa-times modal-close"
              onClick={props.closeModal}
            />
            <EULA
              customEULA={props.customEULA}
              companyName={props.companyName}
            />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default EULAModal
